import { makeStyles } from "makeStyles";
import { PermissionUserIna } from "../models";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import { useState, useMemo } from "react";
import { TableSortOrder, getComparator, SimpleSortableTableHeadProps, SortableTableHead } from "../SortableTableHead";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme),
  vertCenter: {
    "& td": {
      verticalAlign: "middle"
    }
  },
  assignmentTypeCell: {
    width: "100px"
  }
}));

interface Props {
  inas?: PermissionUserIna[];
}

const UsersInas: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof PermissionUserIna>("id");

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof PermissionUserIna) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const displayRows = useMemo(() => [...(props.inas ?? [])].sort(getComparator(order, orderBy)), [order, orderBy, props.inas]);

  function UsersInasTableHead({ id, label, className }: SimpleSortableTableHeadProps<PermissionUserIna>) {
    return (
      <SortableTableHead
        className={className}
        headCell={{
          id,
          label
        }}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
    );
  }

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableHead>
          <TableRow>
            <UsersInasTableHead id="inaName" label="INA Name" />
            <UsersInasTableHead className={classes.assignmentTypeCell} id="viaDefault" label="Default" />
            <UsersInasTableHead className={classes.assignmentTypeCell} id="viaNonAssurance" label="Non- Assurance" />
            <UsersInasTableHead className={classes.assignmentTypeCell} id="viaPprp" label="PPRP PR" />
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows?.map((ina) => (
            <TableRow className={classes.vertCenter} key={ina.id}>
              <TableCell>{ina.inaName}</TableCell>
              <TableCell className={classes.assignmentTypeCell}>{ina.viaDefault ?? "✖️"}</TableCell>
              <TableCell className={classes.assignmentTypeCell}>{ina.viaNonAssurance ?? "✖️"}</TableCell>
              <TableCell className={classes.assignmentTypeCell}>{ina.viaPprp ?? "✖️"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default UsersInas;
